import type { FaireProductEntity } from "../../entity_types/product";

export const p_8cmw479wca: FaireProductEntity = {
  token: "p_8cmw479wca",
  type: "product",
  name: "Long sleeves light blue ice cream sprinkle boys hoodie",
  brandToken: "b_8y38abnnmk",
  brandName: "Yawoo Garments",
  imageUrl:
    "https://cdn.faire.com/fastly/f8983dfa1f1f2ae63f70cf0ad0a307222a516a5d57d0bdbb136796fec8f18179.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dab8a4299593837657c14e13a60283fb84b2cd1585048f2a85dfdc3a6be89b9a.jpeg",
    "https://cdn.faire.com/fastly/52a32c03801057084f7d5a6dec99dd9376f0426d2682a8e5b092901b4253e07f.jpeg",
    "https://cdn.faire.com/fastly/adf6fcdd505aaa1ef4440dc80865d395271f5f73ee20336d877e5bd044e60112.jpeg",
    "https://cdn.faire.com/fastly/70f69871b54b781d81d5bfabe2f92df790b807bbe5aba1fef1d8b93c1f9f5144.jpeg",
    "https://cdn.faire.com/fastly/8e4fb7f6de779175780932bb7fe5f865d904ebcb3af6335a15a105e179f03c53.jpeg",
    "https://cdn.faire.com/fastly/3a27ace7a893de548811e8799fbc0592918f90b7cd2f66c6c737f21590bbeb56.jpeg",
  ],
  priceDollars: 10.5,
  description:
    "Material is milk silk\n\nTrue to size\n\nDelivery time: 3-10 days\n",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:44.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
